<kt-base-modal [emitCloseEvent]="true" (eModalClose)="closeModalHandler()"
  [title]="employeeData?.employee_fk_user_id ? ('Edit People (' +( empoloyeeInfo?.user?.user_first_name  || empoloyeeInfo?.user_first_name  ) + ' ' + (empoloyeeInfo?.user?.user_last_name || empoloyeeInfo?.user_last_name) +  ')')  :'TITLE.CREATE_EMPLOYEE_TITLE' ">
  <div modal-body>
    <kt-loader [showLoader]="loading()">

      <div #wizard class="kt-grid kt-wizard-v2 kt-wizard-v2--white" id="kt_wizard_v2" data-ktwizard-state="step-first">

        <!--begin: Wizard Nav -->
        <div class="kt-grid__item kt-wizard-v2__aside">
          <div class="w-100">
            <div class="kt-widget kt-widget--user-profile-1">
              <!-- begin: Form Wizard Nav -->
              <div class="kt-widget__body">
                <div class="kt-widget__items">

                  <!-- step 1 personal detail -->
                  <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                    (click)="onStepClick(formConstants.PERSONAL_DETAIL)"
                    [class.active-tab]="stepConfig.currentForm === formConstants.PERSONAL_DETAIL"
                    *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_ACCESS : null">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="personal_detail" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/personal_detail.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'EMPLOYEE.PERSONAL_DETAILS' | translate}}
                      </span>
                    </span>
                  </a>

                  <!-- step 2 address -->
                  <a href="javascript:;" data-ktwizard-type="step" (click)="onStepClick(formConstants.ADDRESS)"
                    [class.active-tab]="stepConfig.currentForm === formConstants.ADDRESS" class="kt-widget__item"
                    *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_ACCESS : null">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="address" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/address.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'EMPLOYEE.ADDRESS' | translate}}
                      </span>
                    </span>
                  </a>

                  <!-- step 3  contact -->
                  <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                    [class.active-tab]="stepConfig.currentForm === formConstants.CONTACT"
                    (click)="onStepClick(formConstants.CONTACT)"
                    *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_ACCESS : null">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="contact" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/contact.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'EMPLOYEE.CONTACTS' | translate}}
                      </span>
                    </span></a>

                  <!-- step 4 Job Information -->
                  <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                    [class.active-tab]="stepConfig.currentForm === formConstants.JOB_INFORMATION"
                    (click)="onStepClick(formConstants.JOB_INFORMATION)"
                    *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_ACCESS : null">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="job_information" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/job_information.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'EMPLOYEE.JOB_INFORMATION' | translate}}
                      </span>
                    </span>
                  </a>

                  <!-- step 5 Assign location -->
                  <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                    [class.active-tab]="stepConfig.currentForm === formConstants.ASSIGN_LOCATION"
                    (click)="onStepClick(formConstants.ASSIGN_LOCATION)"
                    *ngxPermissionsOnly="!isLoggedInUserProfile ? PermissionV2.PEOPLE_GENERAL_DETAILS_ACCESS : null">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="assign_location" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/assign_location.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'Assign ' + masterBusinessLabel.Location | translate}}

                      </span>
                    </span>
                  </a>

                  <!-- step 6 Assign Timesheet -->
                  <a class="kt-widget__item " href="javascript:;" data-ktwizard-type="step"
                    [class.active-tab]="stepConfig.currentForm === formConstants.ASSIGN_TIMESHEET"
                    (click)="onStepClick(formConstants.ASSIGN_TIMESHEET)">
                    <span class="kt-widget__section">
                      <span class="kt-widget__icon">
                        <svg-icon aria-label="assign_timesheet" class="employee_action_icon d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/assign_timesheet.svg"></svg-icon>
                      </span>
                      <span class="kt-widget__desc">
                        {{'EMPLOYEE.ASSIGN_TIMESHEET' | translate}}
                      </span>
                    </span>
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v2__wrapper h-100">
          <div class="kt-form">

            <!-- step 1 personal detail -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.PERSONAL_DETAIL" class="kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <kt-personal-detail [personalDetailform]="forms.personalDetailForm.form" [options]="options"
                  [employeeData]="employeeData" [clientId]="clientId" [locationId]="locationId"
                  [screenName]="data?.screenName" [options]="{ class : 'create-mode-class'}"
                  (callback)="childTabCallback($event)">
                </kt-personal-detail>
              </div>
            </ng-container>

            <!-- step 2 address -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.ADDRESS" class="kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <div class="kt-heading kt-heading--md kt-heading--space-sm"> {{'EMPLOYEE.ADDRESS' | translate}}</div>
                <kt-address [form]="forms.addressForm.form" [options]="{ class : 'create-mode-class-emp'}"
                  [from]="isLoggedInUserProfile ? 'PROFILE' : 'EMPLOYEE'"
                  [data]="{ userId: employeeData?.employee_fk_user_id}"></kt-address>
              </div>
            </ng-container>

            <!-- step 3  contact -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.CONTACT" class="kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <div class="kt-heading kt-heading--md kt-heading--space-sm"> {{'EMPLOYEE.CONTACTS' | translate}}</div>
                <kt-contact [form]="forms.contactForm.form" [options]="{ class : 'create-mode-class-emp'}"
                  [from]="isLoggedInUserProfile ? 'PROFILE' : 'EMPLOYEE'"
                  [data]="{ userId: employeeData?.employee_fk_user_id}"></kt-contact>
              </div>
            </ng-container>

            <!-- step 4 Job Information -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.JOB_INFORMATION" class=" kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <kt-client-job-information [options]="options" [options]="{ class : 'create-mode-class'}"
                  [jobInformationForm]="forms.jobInformationForm.form" [employeeData]="employeeData"
                  (callback)="childTabCallback($event)">
                </kt-client-job-information>
              </div>
            </ng-container>

            <!-- step 5 Assign location -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.ASSIGN_LOCATION" class=" kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <kt-assign-location [options]="options" [options]="options"
                  [assignLocationForm]="forms.assignLocationForm.form" [employeeData]="employeeData"
                  (callback)="childTabCallback($event)">
                </kt-assign-location>
              </div>
            </ng-container>

            <!-- step 6 Assign timesheet -->
            <ng-container>
              <div [hidden]="stepConfig.currentForm !== formConstants.ASSIGN_TIMESHEET" class=" kt-wizard-v2__content"
                data-ktwizard-type="step-content" data-ktwizard-state="current">
                <kt-assign-timesheet [options]="options" [options]="options"
                  [assignTimesheetForm]="forms.assignTimesheetForm.form" [employeeData]="employeeData"
                  (callback)="childTabCallback($event)">
                </kt-assign-timesheet>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

    </kt-loader>
  </div>
</kt-base-modal>
